import React, { useState, useEffect } from "react";
import "./style.css";

function AIForm({ formTitle, formData, returnFormData }) {
  const [fields, setFields] = useState({});

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    const initialFields = {};
    for (let i = 0; i < formData.length; i++) {
      initialFields[formData[i].inputName] = "";
    }
    setFields(initialFields);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleChange = (e) => {
    e.preventDefault();
    setFields((prev) => ({
      ...prev,
      [e.target.name]: e.target.value
    }));
  };

  return (
    <div className="formContainer">
      <h3>{formTitle}</h3>
      {/* autoComplete="off" (form + every field) stops Chrome from autofilling the
          signed-in agent's own email/password into staff-facing "create a record"
          forms — a real hazard when the operator is creating someone else's record.
          Fields may override via `autoComplete` on their formData entry. */}
      <form className="form" autoComplete="off">
        {formData.map((form, i) => (
          <div key={i} className="form-input">
            <label>{form.inputLabel}</label>
            <input
              type={form.inputType}
              name={form.inputName}
              autoComplete={form.autoComplete || "off"}
              onChange={(e) => handleChange(e)}
            />
          </div>
        ))}

        <button
          style={{
            color: "white",
            fontSize: "20px",
            boxShadow: "0px 0px 1px 1px black",
            backgroundImage: "linear-gradient(147deg, black 90%, white 0%)",
            padding: "5px 20px 5px 20px",
            borderRadius: "5px"
          }}
          onClick={(e) => returnFormData(e, fields)}
        >
          Submit
        </button>
      </form>
    </div>
  );
}

export default AIForm;
